const dragPositionInitialState = {
  x: 0,
  y: 0
};
const draggedDataInitialState = {
  element: null,
  html: null,
  shift: { x: 0, y: 0 },
  ids: [],
  types: [],
  parent: {
    id: null,
    type: null
  }
};

const dragDropComponentModule = {
  namespaced: true,
  modules: {},
  state: () => ({
    dragPosition: dragPositionInitialState,
    draggedData: draggedDataInitialState
  }),
  getters: {
    dragging: state => {
      return state.draggedData.element !== null;
    },
    isDraggingId: state => id => {
      return true;
      //return state.draggedData.ids.includes(id);
    }
  },
  mutations: {
    setDragPosition(state, { x, y }) {
      state.dragPosition = { x, y };
    },
    resetDragState(state) {
      state.dragPosition = dragPositionInitialState;
      state.draggedData = draggedDataInitialState;
    },
    updateDraggedData(state, val) {
      state.draggedData = val;
    }
  },
  actions: {}
};

export default dragDropComponentModule;
